import _defineProperty from "/home/javi/repos/infomerc/tasa-collectum/ecommerce/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/defineProperty";
import _toConsumableArray from "/home/javi/repos/infomerc/tasa-collectum/ecommerce/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/toConsumableArray";

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

import * as React from "react";
import styled from "styled-components";
import { left as leftRight } from "../../../utils/rtl";
import defaultTheme from "../../../defaultTheme";
export var calculateLeftPosition = function calculateLeftPosition(valueNow, valueMin, valueMax, isFirst, isSimple) {
  // if first, stick it to the left edge
  if (isFirst) {
    // if simple (one handle and without histogram)
    if (isSimple) {
      return +((valueNow - valueMin) / (valueMax - valueMin) * 100).toFixed(1);
    }

    return +((valueNow - valueMin) / (valueMax - valueMin + 1) * 100).toFixed(1);
  } // for every other handle stick on the right edge


  return +((valueNow - valueMin + 1) / (valueMax - valueMin + 1) * 100).toFixed(1);
};
export var isFirst = function isFirst(value, valueNow, index, hasHistogram) {
  if (Array.isArray(value)) {
    var max = Math.max.apply(Math, _toConsumableArray(value));
    var min = Math.min.apply(Math, _toConsumableArray(value));
    var maxEqualsMin = max === min;
    var minEqualsValueNow = min === valueNow;
    if (index !== 0 && maxEqualsMin) return false;
    return maxEqualsMin || minEqualsValueNow;
  }

  return !hasHistogram;
};
var StyledHandle = styled(function (_ref) {
  var left = _ref.left,
      theme = _ref.theme,
      onTop = _ref.onTop,
      props = _objectWithoutProperties(_ref, ["left", "theme", "onTop"]);

  return React.createElement("div", props);
}).attrs(function (_ref2) {
  var _style;

  var left = _ref2.left,
      onTop = _ref2.onTop,
      theme = _ref2.theme;
  return {
    style: (_style = {}, _defineProperty(_style, leftRight({
      theme: theme
    }), "calc(".concat(left, "% - 12px)")), _defineProperty(_style, "zIndex", onTop ? 20 : undefined), _style)
  };
}).withConfig({
  displayName: "Handle__StyledHandle",
  componentId: "sc-1douguf-0"
})(["display:flex;position:absolute;right:0;bottom:0;flex:0 0 24px;align-items:center;justify-content:center;box-sizing:border-box;width:24px;height:24px;border-radius:24px;box-shadow:", ";background-color:", ";cursor:pointer;transition:box-shadow ", " ease-in-out;-webkit-tap-highlight-color:transparent;-webkit-touch-callout:none;-webkit-user-select:none;:after{content:\"\";display:block;width:8px;height:8px;background-color:", ";border-radius:8px;}:hover,:focus,:active{outline:none;box-shadow:", ";}"], function (_ref3) {
  var theme = _ref3.theme;
  return theme.orbit.boxShadowAction;
}, function (_ref4) {
  var theme = _ref4.theme;
  return theme.orbit.paletteWhite;
}, function (_ref5) {
  var theme = _ref5.theme;
  return theme.orbit.durationFast;
}, function (_ref6) {
  var theme = _ref6.theme;
  return theme.orbit.paletteProductNormal;
}, function (_ref7) {
  var theme = _ref7.theme;
  return theme.orbit.boxShadowActionActive;
});
StyledHandle.defaultProps = {
  theme: defaultTheme
};

var Handle = function Handle(_ref8) {
  var tabIndex = _ref8.tabIndex,
      onMouseDown = _ref8.onMouseDown,
      onFocus = _ref8.onFocus,
      onTouchStart = _ref8.onTouchStart,
      valueMax = _ref8.valueMax,
      valueMin = _ref8.valueMin,
      onTop = _ref8.onTop,
      value = _ref8.value,
      index = _ref8.index,
      ariaValueText = _ref8.ariaValueText,
      ariaLabel = _ref8.ariaLabel,
      hasHistogram = _ref8.hasHistogram;
  var valueNow = Array.isArray(value) ? value[index] : value;
  var first = isFirst(value, valueNow, index, hasHistogram);
  var isSimple = !hasHistogram && !Array.isArray(value);
  var left = calculateLeftPosition(valueNow, valueMin, valueMax, first, isSimple);
  return React.createElement(StyledHandle, {
    tabIndex: tabIndex,
    onTop: onTop,
    role: "slider",
    onMouseDown: onMouseDown,
    onFocus: onFocus,
    onTouchStart: onTouchStart,
    "aria-valuemax": valueMax,
    "aria-valuemin": valueMin,
    "aria-valuenow": valueNow,
    "aria-label": Array.isArray(ariaLabel) && typeof index !== "undefined" ? ariaLabel[index] : ariaLabel,
    "aria-valuetext": ariaValueText,
    left: left
  });
};

export default Handle;